import * as yup from "yup";

export const schema = yup.object().shape({
    url: yup.string().trim().required('Please input url').url('Invalid website URL'),
});
